import {
    HttpEditProjectSocialWelfareConditionsPayload,
    httpEditProjectSocialWelfareConditions
} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useEditSocialWelfareConditions = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectSocialWelfareConditionsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpEditProjectSocialWelfareConditionsPayload) =>
            httpEditProjectSocialWelfareConditions({urlParams, payload})
    })
}
